import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchFollowUpAttachments } from "../redux/attachments/attachmentsActions";

export const useFollowUpAttachments = (referenceTicketNumber) => {
    const dispatch = useDispatch();
    const followupAttachments = useSelector((state) => state.attachments.followupAttachments);
    const attachmentsFound = useMemo(() => {
        if (!referenceTicketNumber || !followupAttachments) {
            return [];
        }
        return followupAttachments[referenceTicketNumber] || [];
    }, [followupAttachments, referenceTicketNumber]);

    useEffect(() => {
        if (referenceTicketNumber) {
            dispatch(fetchFollowUpAttachments(referenceTicketNumber));
        }
    }, [referenceTicketNumber]);

    return attachmentsFound;
};
